import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { OrderSummaryRow } from './OrderSummaryRow';
import { translate } from '../translate';

export const OrderSummaryBox = ({ summary }) => (
  <View style={styles.box}>
    <Text style={styles.rowHeader}>{translate('yourOrder')}</Text>
    <OrderSummaryRow k={translate('orderNumber')} v={summary.orderNumber} />
    <OrderSummaryRow k={translate('vatId')} v={summary.vatId} />
    <OrderSummaryRow k={translate('season')} v={summary.season} />
    <OrderSummaryRow k={translate('orderType')} v={summary.orderType} />
    <OrderSummaryRow k={translate('orderDate')} v={summary.orderDate} />
    <OrderSummaryRow k={translate('association')} v={summary.association} />
    <OrderSummaryRow k={translate('associationId')} v={summary.associationId} />
    <OrderSummaryRow k={translate('sellerNo')} v={summary.sellerNumber} />
    <OrderSummaryRow k={translate('invoiceNo')} v={summary.invoiceNumber} />
    <OrderSummaryRow
      k={translate('minDeliveryDate')}
      v={summary.minDeliveryDate}
    />
  </View>
);
